/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/enterprise/newConnection/EnterpriseNewConnectionPanel" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { EnterpriseNewConnection } from "Wit/Settings/BoardsExternalIntegration/components/common";
import { BasePanel } from "Wit/Settings/BoardsExternalIntegration/components/panels/BasePanel";
import { IEnterpriseNewConnectionPanelProps } from "Wit/Settings/BoardsExternalIntegration/components/panels/enterprise/newConnection/EnterpriseNewConnectionPanel.Props";
import * as Resources from "Wit/Settings/BoardsExternalIntegration/Resources";

export interface IEnterpriseNewConnectionPanelState {
    errorMessage?: string;
    loadingSpinnerMessage?: string;
}

export class EnterpriseNewConnectionPanel extends VssComponent<
    IEnterpriseNewConnectionPanelProps,
    IEnterpriseNewConnectionPanelState,
    IVssComponentContext
> {
    constructor(props: IEnterpriseNewConnectionPanelProps, context: IVssComponentContext) {
        super(props, context);

        this.state = {
            errorMessage: undefined,
            loadingSpinnerMessage: undefined
        };
    }

    public render() {
        return (
            <BasePanel
                onDismiss={this.props.onDismiss}
                className="new-connection-panel"
                title={Resources.NewConnection_title}
                onRenderHeaderContent={this._renderHeader}
                errorMessage={this.state.errorMessage}
                onDismissErrorMessage={this._onDismissErrorMessage}
                loadingSpinnerMessage={this.state.loadingSpinnerMessage}
            >
                <EnterpriseNewConnection showPanel={this.props.showPanel} disableOAuth={this.props.disableOAuth} />
            </BasePanel>
        );
    }

    private _onDismissErrorMessage = () => {
        this.setState({ errorMessage: undefined });
    };

    private _renderHeader = (): JSX.Element => {
        return <div>{Resources.NewConnection_subheader}</div>;
    };
}
